import Image from "next/image";
import Title from "./common/Title";
import Container from "@/components/common/Container";

const Solutions = () => (
  <Container className="bg-gradient-solution-Image-mobile md:bg-gradient-solution-Image-Bg">
    <Title
      className="md:pl-16 xl:pl-24 pb-20 xl:pb-24 w-full md:w-4/5 xl:w-3/4"
      customClass="text-white pb-40 xl:pb-10 pb-6"
      Description="Our solution addresses the challenges and goals of users like CryptoTrader Don by designing a blockchain-based digital asset trading platform that seamlessly merges cutting-edge technology with user-centric design principles. The platform boasts a streamlined, intuitive interface that facilitates rapid trade execution, ensuring that traders can capitalize on market opportunities without unnecessary complexity. <br/><br/> Real-time market data, customizable watchlists, and detailed asset information empower users to stay informed and make informed trading decisions. To address security concerns, the platform integrates robust encryption, multi-factor authentication, and secure cold storage for digital assets. Additionally, we offer educational resources to keep traders updated on regulatory changes and best practices. By combining a user-friendly experience with advanced security measures, our platform enables traders like Don to navigate the cryptocurrency market confidently and efficiently."
      SubTitle="Solutions"
    />
    <Container small>
      <Image
        alt="userprofile"
        height={827}
        src={"/assets/case-study/mobifinx/mobifinx.webp"}
        width={1121}
      />
    </Container>
  </Container>
);

export default Solutions;
